module.exports = __webpack_public_path__ + "img/morton.f77b6d88.jpeg";